import { LocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SimpleModalService } from 'ngx-simple-modal';
import { Constants } from '../common/constants';
import { GUI } from '../common/gui';
import { LocalStorage } from '../common/local-storage';
import { SearchModalComponent } from '../search-modal/search-modal.component';

declare function clickDropdownClass(): any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  loggedUserFullName : string = this.constants.BLANK;

  constructor(private location: LocationStrategy, private constants: Constants, private localStorage: LocalStorage, private gui: GUI, private simpleModalService: SimpleModalService) {
    history.pushState(null, null, window.location.href);  
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
    this.loggedUserFullName = this.localStorage.getLoggedUserFullName();
    
  }

  ngOnInit() : void {
    clickDropdownClass();
  }

  doLogout() {
    this.gui.openLogoutPage();
  }

  openSearchModel(){
    this.simpleModalService.addModal(SearchModalComponent, {isUnpaidSearch: this.constants.FALSE}, {autoFocus: true}).subscribe((isApplicationAdded: boolean)=> {

    });
  }

}
